<script setup lang="ts">
import { ref } from 'vue'

withDefaults(
  defineProps<{
    text: string
    /**
     * True when the slot already contains a focusable element (button/link).
     * The tooltip does NOT add its own focusable wrapper, avoiding double tab-stops.
     * Uses focusin/focusout which bubble from the child.
     */
    interactive?: boolean
  }>(),
  { interactive: false },
)

const open = ref(false)
</script>

<template>
  <span
    class="relative inline-flex"
    @mouseenter="open = true"
    @mouseleave="open = false"
    @focusin="open = true"
    @focusout="open = false"
  >
    <!-- Non-interactive content: keep the historical focusable wrapper. -->
    <span v-if="!interactive" tabindex="0" class="inline-flex cursor-default">
      <slot />
    </span>
    <!-- Interactive content: slot directly, no extra wrapper. -->
    <slot v-else />

    <span
      v-if="open"
      class="absolute bottom-full left-1/2 z-10 mb-1 w-max max-w-50 -translate-x-1/2 rounded bg-background px-2 py-1 text-[11px] whitespace-normal text-fg-primary shadow-lg"
    >
      {{ text }}
    </span>
  </span>
</template>
